import { UPDATE_TRANSLATIONS } from "../sc-core/Auth/store/actionTypes";

export const updateTranslations = (translations) => {
    return {
        type: UPDATE_TRANSLATIONS,
        translations: translations,
    };
};
export const getBrowserLanguage = () => {
    // Getting first two letters because of language codes like en-US, de-AT etc
    return navigator.language.length > 2
        ? navigator.language.substring(0, 2)
        : navigator.language;
};